import { render, staticRenderFns } from "./KInplay.vue?vue&type=template&id=c66a4ef6"
import script from "./KInplay.vue?vue&type=script&lang=js"
export * from "./KInplay.vue?vue&type=script&lang=js"
import style0 from "./KInplay.vue?vue&type=style&index=0&id=c66a4ef6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports